import { useEffect } from "react";
import "./ExcluirDesvioNegarModal.css";

export default function ExcluirDesvioNegarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dvenxm-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dvenxm-modal" role="dialog" aria-modal="true" aria-label="Excluir item">
        <header className="dvenxm-header">
          <h3 className="dvenxm-title">Excluir</h3>
          <button type="button" className="dvenxm-close" aria-label="Fechar" onClick={onClose}>
            x
          </button>
        </header>

        <div className="dvenxm-body">
          Tem certeza que deseja <strong>excluir</strong> "{label || "este item"}"?
        </div>

        <footer className="dvenxm-footer">
          <button type="button" className="dvenxm-btn dvenxm-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dvenxm-btn dvenxm-btn--danger" onClick={onConfirm}>
            Excluir
          </button>
        </footer>
      </div>
    </div>
  );
}
